import { Redirect, Route, Switch, useParams, useRouteMatch } from "react-router-dom";
import { Itemset } from "../../store/viewmodels/ItemsetViewModel";
import { Task } from "../../store/viewmodels/TaskViewModel";
import { getNextItemId } from "../../utils/TaskNavigationServices";
import StudentItem from "./StudentItem";
import { getItemset, sortItemsInItemset } from "../../utils/TaskContentServices";


interface StudentItemsetParams {
    itemsetId: string
}

interface StudentItemsetProps {
    task: Task
}

function StudentItemset(props: StudentItemsetProps) {
    let { itemsetId } = useParams<StudentItemsetParams>();
    let { path, url } = useRouteMatch();
    let itemset: Itemset = getItemset(props.task, itemsetId);
    const sortedItemset: Itemset = sortItemsInItemset(itemset)
    let nextItemId: string = getNextItemId(sortedItemset)
    let redirect = nextItemId.length > 0 ? <Redirect to={`${url}/items/${nextItemId}`} /> : <Redirect to="/student/tasks" />

    return (
        <Switch>
            <Route exact path={path}>
                {redirect}
            </Route>
            <Route path={`${path}/items/:itemId`}>
                <StudentItem task={props.task} itemset={sortedItemset} />
            </Route>
        </Switch>
    );
}

export default StudentItemset;